import { useCommunityContext } from 'providers';
import { useMemo } from 'react';

import { RoleAddonFragment, useCurrentUserRoleAddonsQuery } from 'shared/graphql';

import { useHasSession } from './useHasSession';

/**
 * Custom hook that retrieves the current user's role addons.
 * @returns An object containing the current user's role addons.
 */
export function useCurrentUserRoleAddons() {
  const hasSession = useHasSession();

  const { selectedCommunity: school, loading: schoolLoading } = useCommunityContext();

  const { data: response, loading: rolesLoading } = useCurrentUserRoleAddonsQuery({
    skip: !school?.id || !hasSession,
    variables: {
      school: school?.id as string,
    },
  });

  const roles: RoleAddonFragment[] = useMemo(() => response?.rolesAddons?.items ?? [], [response]);

  return {
    data: roles,
    loading: rolesLoading || schoolLoading,
  };
}
